import {
  ApartmentOutlined,
  CloudDownloadOutlined,
  DatabaseOutlined,
  InfoCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { t } from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import ResponsiveTabs, {
  TabItem,
} from '../../../components/display/ResponsiveTab'
import { routePaths } from '../../RootPage'
import {
  WorkspaceTab,
  workspaceTabs,
  workspacePanelTypes,
} from '../WorkspaceDetailsPage'

interface WorkspaceTabsProps {
  singleWorkspace?: boolean
}

const WorkspaceTabs = ({ singleWorkspace }: WorkspaceTabsProps) => {
  const { panelType, tab, workspaceId, deviationId } = useParams()
  const navigate = useNavigate()

  const tabs: TabItem[] = [
    {
      key: workspaceTabs.INFO,
      icon: <InfoCircleOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabInfo'),
    },
    {
      key: workspaceTabs.SMART_FUNCTION,
      icon: <ApartmentOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabIntelligentSolution'),
      visible: !panelType || panelType === workspacePanelTypes.OVERVIEW,
    },
    {
      key: workspaceTabs.SOURCE,
      icon: <DatabaseOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabSource'),
      visible: panelType === workspacePanelTypes.SETTINGS,
    },
    {
      key: workspaceTabs.STORE,
      icon: <CloudDownloadOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabStore'),
      visible: panelType === workspacePanelTypes.SETTINGS,
    },
    {
      key: workspaceTabs.PEOPLE,
      icon: <TeamOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabPeople'),
      visible: panelType === workspacePanelTypes.SETTINGS,
    },
  ]

  const selectedTab = (tab || workspaceTabs.INFO) as WorkspaceTab

  const handleChange = (value: string) => {
    const baseRoute = singleWorkspace
      ? routePaths.SINGLE_WORKSPACE_DETAILS
      : routePaths.WORKSPACE_DETAILS
    const deviationIdString = deviationId ? `\\${deviationId}` : ''
    navigate(
      `${baseRoute}/${workspaceId}/${
        panelType || workspacePanelTypes.OVERVIEW
      }/${value}${deviationIdString}`
    )
  }

  return (
    <ResponsiveTabs
      tabs={tabs}
      selectedTab={selectedTab}
      onTabChange={handleChange}
    />
  )
}

export default WorkspaceTabs
